import * as React from 'react';
import { css, html } from 'react-strict-dom';

type Props = Readonly<{
  children: React.ReactNode;
}>;

export default function AuthPageWrap({ children }: Props) {
  return <html.div style={styles.pageWrap}>{children}</html.div>;
}

const styles = css.create({
  pageWrap: {
    minHeight: '100vh',
    backgroundImage: 'linear-gradient(to bottom, #3f1d56, #892953)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#444',
    paddingBlock: 30,
    paddingInline: {
      default: 30,
      '@media (max-width: 400px)': 0,
    },
    boxSizing: 'border-box',
  },
});
